import { get } from 'helpers/api';

export const ACTIVITIES_LOAD_STARTED = 'ACTIVITIES_LOAD_STARTED';
function loadStarted(abortController) {
  return {
    type: ACTIVITIES_LOAD_STARTED,
    abortController,
  };
}

export function loadActivities() {
  return async (dispatch, getState) => {
    const { deal, activitiesSearch: search } = getState();

    if (search.abortController) {
      search.abortController.abort();
    }

    const abortController = new AbortController();
    dispatch(loadStarted(abortController));

    const response = await get(deal.activitiesPath, {
      signal: abortController.signal,
    });

    dispatch(setActivities(response.activities));
  };
}

export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export function setActivities(activities) {
  return {
    type: SET_ACTIVITIES,
    activities,
  };
}
